<div class="report-description-module">
    <div *ngIf="!isIndividualBriefReport" class="caption">{{ 'lang.common.name'  | translate }}:</div>
    <div class="title">{{ processInfoReport.name }}</div>
    <div *ngIf="isIndividualBriefReport">
      {{ processInfoReport.description }}
    </div>
  </div>
